import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, shareReplay } from 'rxjs/operators';
import { ErrorService } from '@app/services/error.service';
import { InventorySchema, InventorySchemaList } from '@data/models/inventory-schema.model';
import { toParams } from '@shared/utils/query-to-params';
import { firstValueFrom } from 'rxjs';

export const INVENTORY_SCHEMA_SERVICE_API_ROOT = '/asset/v1/inventory/schemas';

@Injectable()
export class InventorySchemaService {

    public schemas: Promise<InventorySchema[]>;
    private errors;

    constructor(
        private errorService: ErrorService,
        private http: HttpClient
    ) {
        this.errors = this.errorService.inventoryServiceErrors;
        this.schemas = this.getInventorySchema();
    }

    public async getInventorySchema(): Promise<InventorySchema[]> {
        const { schemas , totalSize} = await this.fetchInventorySchemas();
        if ( totalSize > schemas.length ){
            for ( let i = 2; totalSize > schemas.length; i++ ){
                const results = await this.fetchInventorySchemas(i);
                schemas.push(...results.schemas);
            }
        }

        return schemas;
    }

    public async fetchInventorySchemas(page?: number): Promise<InventorySchemaList> {
        const params = toParams({ sort: 'type,subtype' , page : page ?? 1, includeTotal: true });
        return firstValueFrom(this.http.get<InventorySchemaList>(INVENTORY_SCHEMA_SERVICE_API_ROOT,
            {
                params,
            })
            .pipe(
                shareReplay(1),
                catchError(
                    this.errorService.errorHandler<InventorySchemaList>(this.errors, 'Récupération des schemas d\'inventaire', null)
                )
            ));
    }

}
